var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"sec-nav"},[_vm._l((_vm.items),function(item){return [_c('li',{key:item},[_c('a',{attrs:{"href":item.url}},[_vm._v(_vm._s(item.txt))])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }